import { render } from "./rightSideBar.vue?vue&type=template&id=62638f31"
import script from "./rightSideBar.vue?vue&type=script&lang=js"
export * from "./rightSideBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__